{
  "SearchAvailabilityInput": {
    "availability": "Dostępność",
    "clear": "Wyczyść",
    "from": "Od",
    "to": "Do",
    "date": "Data",
    "selectDates": "Wybierz daty"
  },
  "ResourceMetaFilters": {
    "available": "Dostępny"
  },
  "GenericSearch": {
    "Filter": "Filter",
    "Tags": "Tagi",
    "Belongs to me": "Należy do mnie",
    "Published only": "Tylko opublikowane",
    "Drafts only": "Tylko wersje robocze",
    "Last week": "Ostatni tydzień",
    "Show archived": "Pokaż zarchiwizowane",
    "sorts": {
      "Created": "Utworzono",
      "Updated": "Zaktualizowano"
    }
  },
  "TagsFilter": {
    "Tags": "Tagi",
    "matchAll": "Pasuje do wszystkich",
    "matchAny": "Pasuje do dowolnego",
    "addTag": "Dodaj tag",
    "add": "Dodaj"
  },
  "SearchSorts": {
    "sortBy": "Sortuj według",
    "sorts": {
      "Created": "Utworzono",
      "Updated": "Zaktualizowano",
      "Production Date": "Data produkcji",
      "Applied Date": "Data aplikacji",
      "Next Up": "Następne",
      "Last Updated": "Ostatnio zaktualizowane",
      "Booking Status": "Status rezerwacji"
    }
  },
  "StatusSelectorMultiple": {
    "filterStatus": "Filtruj status",
    "showAll": "Pokaż wszystko"
  },
  "ResourceAdvancedSearch": {
    "addFilters": "Dodaj filtry",
    "clearAll": "Wyczyść wszystkie"
  },
  "SearchField": {
    "editGroups": "Edytuj grupy",
    "clear": "Wyczyść",
    "labels": {
      "Location": "Lokalizacja",
      "Tags": "Tagi",
      "Groups": "Grupy",
      "Rates": "Stawki"
    },
    "select": "Wybierz",
    "search": "Szukaj {{label}}",
    "measurementsUnitsInfo": "Filtrowanie będzie obejmować wszystkie jednostki",
    "searchLocation": "Wyszukaj lokalizację",
    "currency": {
      "select": "Wybierz",
      "searchPlaceholder": "Szukaj {{label}}"
    },
    "singleSelect": {
      "defaultPlaceholder": "Wybierz opcję i naciśnij Enter"
    },
    "tagSelect": {
      "defaultPlaceholder": "Wybierz taga i naciśnij Enter"
    },
    "resourceSelect": {
      "defaultPlaceholder": "Wybierz kontakt i naciśnij Enter"
    },
    "multiSelect": {
      "defaultPlaceholder": "Wybierz opcję i naciśnij Enter"
    },
    "searchTypes": {
      "LONG_TEXT": {
        "eq": "Równa się"
      },
      "PERCENTAGE": {
        "eq": "Równa się"
      },
      "SHORT_TEXT": {
        "eq": "Równa się",
        "s_with": "Zaczyna się od",
        "e_with": "Kończy się na",
        "contains": "Zawiera"
      },
      "BOOLEAN": {
        "eq": "Równa się"
      },
      "NUMBER": {
        "eq": "Równa się",
        "gte": "Większe niż",
        "lte": "Mniejsze niż"
      },
      "CURRENCY": {
        "eq": "Równa się",
        "gte": "Większe niż",
        "lte": "Mniejsze niż"
      },
      "MULTI_SELECT": {
        "match": "Pasuje",
        "any": "Dowolne"
      },
      "TAG_SELECT": {
        "match": "Pasuje",
        "any": "Dowolne"
      },
      "RESOURCE_SELECT": {
        "match": "Pasuje"
      },
      "SINGLE_SELECT": {
        "eq": "Równa się"
      },
      "DATE": {
        "eq": "Równa się"
      },
      "URL": {
        "eq": "Równa się"
      },
      "MEASUREMENT": {
        "eq": "Równa się",
        "gte": "Większe niż",
        "lte": "Mniejsze niż"
      },
      "NETSUITE_VENDOR": {
        "eq": "Równa się"
      },
      "HEIGHT": {
        "eq": "Równa się",
        "gte": "Większe niż",
        "lte": "Mniejsze niż"
      },
      "NETSUITE_PO": {
        "eq": "Równa się"
      }
    },
    "matchingTypes": {
      "matchingType": "Typ dopasowania",
      "match": "Pasuje do wszystkich",
      "any": "Pasuje do dowolnego"
    }
  },
  "TagInput": {
    "add": "Dodaj tag",
    "add_many": "Dodaj"
  },
  "SelectResourceGroup": {
    "groups": "Grupy",
    "all": "Wszystkie",
    "groupSelected": "{{count}} wybrana grupa",
    "groupSelected_all": "Wszystkie grupy",
    "groupSelected_few": "{{count}} wybrane grupy",
    "groupSelected_many": "{{count}} wybranych grup"
  },
  "NoteItem": {
    "archive": "Archiwizuj"
  },
  "EventDateRange": {
    "labelStart": "Rozpoczęcie",
    "labelEnd": "Zakończenie",
    "addAnotherDate": "Dodaj kolejną datę"
  },
  "EventHoursInput": {
    "hoursLabel": "Godziny"
  },
  "EventHelper": {
    "allDay": "Cały dzień",
    "recurringLabel": "{{hours}}h{{minutes}} / dzień"
  },
  "Loading": {
    "justAMoment": "Ładowanie"
  },
  "FileUploader": {
    "uploading": "Wysyłanie",
    "complete": "Zakończone",
    "dragFilesHereOr": "Przeciągnij pliki tutaj lub",
    "clickToUpload": "Kliknij, aby przesłać",
    "maxFileUploadSize": "Przekroczono maksymalny rozmiar pliku."
  },
  "FileUploadingItem": {
    "untitledFile": "Bez tytułu",
    "failed": "BŁĄD",
    "complete": "ZAKOŃCZONE"
  },
  "EventHoursInputOptions": {
    "allDay": "Cały dzień",
    "hoursPerDay": "Godziny dziennie",
    "hours": "Godziny",
    "minutes": "Minuty",
    "specificTimes": "Konkretne godziny",
    "from": "Od",
    "to": "Do"
  }
}
